module.exports = __webpack_public_path__ + "img/avatar7.4652cfa9.png";